import {TreemapController, TreemapElement} from 'chartjs-chart-treemap';
import {createTypedChart} from './typed-chart-factory';
import {FunnelController, TrapezoidElement} from "chartjs-chart-funnel";
import {CategoryScale, LinearScale, Tooltip} from "chart.js";
import {BoxAndWiskers, BoxPlotController, Violin as _Violin, ViolinController} from "@sgratzl/chartjs-chart-boxplot";
import {BubbleMapController, ChoroplethController, ColorScale, GeoFeature, ProjectionScale, SizeScale} from "chartjs-chart-geo";
import {MatrixController, MatrixElement} from "chartjs-chart-matrix";
import {LinearAxis, LineSegment, LogarithmicAxis, LogarithmicParallelCoordinatesController, ParallelCoordinatesController, PCPScale} from 'chartjs-chart-pcp';
import {Flow, SankeyController} from "chartjs-chart-sankey";
import {ArcSlice, VennDiagramController} from "chartjs-chart-venn";

export {createTypedChart} from './typed-chart-factory';

export const TreemapChart = createTypedChart('treemap', [Tooltip, TreemapController, TreemapElement]);

export const FunnelChart = createTypedChart('funnel', [FunnelController, TrapezoidElement, CategoryScale, LinearScale]);

export const BoxplotChart = createTypedChart('boxplot', [BoxPlotController, BoxAndWiskers, CategoryScale, LinearScale]);

export const ViolinChart = createTypedChart('violin', [ViolinController, _Violin, LinearScale, CategoryScale]);

export const ChoroplethChart = createTypedChart('choropleth', [ChoroplethController, GeoFeature, ColorScale, ProjectionScale]);

export const BubbleMapChart = createTypedChart('bubbleMap', [BubbleMapController, GeoFeature, SizeScale, ProjectionScale]);

export const MatrixChart = createTypedChart('matrix', [MatrixController, MatrixElement]);

export const SankeyChart = createTypedChart('sankey', [SankeyController, Flow]);

export const LinearParallelCoordinatesPlotChart = createTypedChart('pcp', [ParallelCoordinatesController, LinearAxis, LineSegment, PCPScale]);

export const LogarithmicParallelCoordinatesPlotChart = createTypedChart('logarithmicPcp', [LogarithmicParallelCoordinatesController, LogarithmicAxis, LineSegment, PCPScale]);

export const VennDiagramChart = createTypedChart('venn', [VennDiagramController, ArcSlice, LinearScale]);